module.exports = {
  web: {
    key: 'web',
    label: 'Web',
  },
  mobile: {
    key: 'mobile',
    label: 'Mobile',
  },
  android: {
    key: 'android',
    label: 'Android',
  },
  ios:  {
    key: 'ios',
    label: 'IOS',
  },
};